import { useState } from "react";
import { api } from "../../../../../../../../../utility/api";

export const CierreInventarioApi = () => {
    const [cargando, setCargando] = useState(false);

    const getTotalesEnviadosProduccion = async (idInventario) => {
        try {
            setCargando(true);
            const response = await api.get(
                `almacen_inventario/${idInventario}/enviado_produccion_por_padre`
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const cerrarInventario = async (idInventario) => {
        try {
            setCargando(true);

            const response = await api.post(
                `historico_inventarios/${idInventario}/cerrar_inventario`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getTotalesEnviadosProduccion,
        cerrarInventario,

        cargando,
    };
};
